import React, { useEffect, useState } from 'react';
import MenuList from './MenuList';


export const ParentMenu = ({ childMenu }) => {
  const [currentMenu, setCurrentMenu] = useState([]);
  const [subMenu, setSubMenu] = useState('');
  const [showSubMenu, setShowSubMenu] = useState(true);
  useEffect(() => {
    setCurrentMenu([childMenu?.[0]?.name])
  }, [window.location.href, childMenu])

  const handleMenuClick = (menuPath, index, showSubMenu = true) => {
    setCurrentMenu((prevMenu) => {
      return prevMenu[index] === menuPath?.[index]
        ? [...prevMenu, menuPath?.[index]]
        : menuPath;
    });
    let heading = menuPath?.length > 1 ? menuPath?.[1] : '';
    setSubMenu(heading);
    setShowSubMenu(showSubMenu)
  };
  const showMenuHeader = () => {
    const item = childMenu?.filter((menu) => menu?.name === currentMenu?.[0]);
    if (item?.length && !item?.[0]?.child?.length) {
      return false
    }
    return true;
  }
  const renderMenu = () => {
    return !!childMenu?.length && (
      childMenu?.map((node, index) => {
        if (index === 0) {
          return (<>
            <MenuList
              data={node}
              currentMenu={[...currentMenu, node?.name]}
              onMenuClick={handleMenuClick} />
          </>
          )
        }
        return <>
          <MenuList
            data={node}
            currentMenu={currentMenu}
            onMenuClick={handleMenuClick} />
        </>
      })
    )
  }

  return <>
    <span className='top-heading heading_L1 hidden-xs'>{currentMenu?.length && showMenuHeader() ? currentMenu?.[0] : null}</span>
    <span className='top-heading heading_L2 hidden-xs'>{showSubMenu ? subMenu : ""}
    </span>
    {renderMenu()}</>

}

export default ParentMenu